import { VisitMedicalEventStatus } from '@dreryk/egabinet-visit-frontend-api';

import { MedicalEventStatusIcon } from '../../../medicalEvents/MedicalEventStatusIcon';

type MedicalEventCellProps = {
   readonly visitMedicalEventStatus?: VisitMedicalEventStatus;
};

const MedicalEventCell = (props: MedicalEventCellProps): JSX.Element | null => {
   if (!props.visitMedicalEventStatus) {
      return null;
   }

   return <MedicalEventStatusIcon visitMedicalEventStatus={props.visitMedicalEventStatus} testId={'medicalEvent'} />;
};

export { MedicalEventCell };
